










import { Vue, Component, Prop, Model } from "vue-property-decorator";
import {
	busy,
	VIPCertificateConstraint,
	VIPCertificateConstraintToArray,
	VIPCertificateConstraintFromArray,
} from "@/loader";

@Component
export default class CertificateConstraintInput extends Vue {
	@Prop({ type: String, default: "outline-info" })
	public variant!: string;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	@Model("input", { type: Number, required: true })
	public readonly value: VIPCertificateConstraint;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get items(): any[] {
		return [
			{
				value: VIPCertificateConstraint.pedestrian,
				text: "Circulation piétonne",
			},
			{
				value: VIPCertificateConstraint.car,
				text: "Circulation automobile",
			},
			{
				value: VIPCertificateConstraint.network,
				text: "Encombrement dû à des réseaux enterrés ou aériens",
			},
			{
				value: VIPCertificateConstraint.cramped,
				text: "Travaux en voie étroite ou en impasse",
			}
		];
	}

	public get active(): VIPCertificateConstraint[] {
		return VIPCertificateConstraintToArray(this.value);
	}
	public set active(value: VIPCertificateConstraint[]) {
		this.$emit("input", VIPCertificateConstraintFromArray(value));
	}
}
